import { render, staticRenderFns } from "./VmcCrewFamilyParty2023.vue?vue&type=template&id=8fc7bd9c&scoped=true"
import script from "./VmcCrewFamilyParty2023.vue?vue&type=script&lang=js"
export * from "./VmcCrewFamilyParty2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc7bd9c",
  null
  
)

export default component.exports